import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center" }
const _hoisted_2 = { class: "bg-white mt-5 p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6 w-md" }
const _hoisted_3 = { class: "space-y-6 border-t border-gray-100 p-5 sm:p-6 dark:border-gray-800" }
const _hoisted_4 = { class: "pt-5" }
const _hoisted_5 = { class: "text-red-500 text-center" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-800 dark:text-white/90 flex justify-between items-center" }, " Login ", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Username ", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.username) = $event)),
              tabindex: "110",
              onKeyup: _cache[1] || (_cache[1] = _withKeys($event => ($setup.login({username: $setup.username, password: $setup.password})), ["enter"])),
              class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
              [_vModelText, $setup.username]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Password ", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.password) = $event)),
              tabindex: "120",
              onKeyup: _cache[3] || (_cache[3] = _withKeys($event => ($setup.login({username: $setup.username, password: $setup.password})), ["enter"])),
              class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
              [_vModelText, $setup.password]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString($setup.errors), 1 /* TEXT */),
            _createVNode(_component_basic_button, {
              onClick: _cache[4] || (_cache[4] = $event => ($setup.login({username: $setup.username, password: $setup.password})))
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" Login "),
                _createElementVNode("i", { class: "fa-solid fa-key" }, null, -1 /* CACHED */)
              ])),
              _: 1 /* STABLE */,
              __: [7]
            })
          ])
        ])
      ])
    ])
  ]))
}